"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.agency = void 0;
const basic_1 = require("../basic");
const font_faces_1 = require("./font-faces");
exports.agency = (0, basic_1.applyBase)({
    mapSearch: {
        wrapper: {
            position: 'relative',
            paddingBottom: [null, '70px'],
            mb: [null, '47px'],
        },
        box: {
            position: 'absolute',
            width: 'calc(100vw - 50px)',
            maxWidth: [null, '970px'],
            backgroundColor: 'white',
            top: ['23px', 'auto'],
            bottom: [null, '-15px'],
            left: '50%',
            transform: 'translateX(-50%)',
            borderRadius: 'default',
            boxShadow: '0 2px 7px 2px rgba(0,0,0,0.22)',
            zIndex: 2,
            pb: [null, 3],
            pt: [null, '30px'],
            px: [null, '30px'],
            '.map-search-controls': {
                mb: [null, '15px'],
            },
        },
        geo: Object.assign(Object.assign({}, font_faces_1.FONT_SIZE.LINK_LARGE), { display: 'flex', flexDirection: 'row', alignItems: 'center', '.icon': {
                marginRight: '10px',
            } }),
    },
});
//# sourceMappingURL=agency.js.map